import type { SelectOptionsRequestDto } from "@advanced-sales-technologies/backend-client/models/SelectOptionsRequestDto";
import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type OptionParams = {
  id: string;
  companyId: string;
  option: SelectOptionsRequestDto;
};

export const useGetOfficePhoneOptions = (optionParams: OptionParams, enabled: boolean) => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: ["get-office-options-phone", optionParams],
    queryFn: () =>
      apiClient.selectOptions.getOfficePhoneNumberOptions({
        id: optionParams.id,
        companyId: optionParams.companyId,
        requestBody: optionParams.option,
      }),
    enabled: enabled,
  });
};
